export default {
  form: {
    padding: 10,
  },
  addItem: {
    margin: 10,
  },
  addItemContainer: {
    textAlign: 'right',
  },
  body: {
    padding: 10,
  },
};



// WEBPACK FOOTER //
// ./src/components/Admin/TaskProfiles/TaskProfileDialog/styles.js